import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 15"
}, n = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 1.334a6.167 6.167 0 1 0 0 12.333A6.167 6.167 0 0 0 8 1.334M.833 7.5a7.167 7.167 0 1 1 14.333 0 7.167 7.167 0 0 1-14.333 0",
  "clip-rule": "evenodd"
}, null, -1), r = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 4.667a.833.833 0 0 0-.834.833.5.5 0 0 1-1 0 1.833 1.833 0 1 1 3.376.991 6 6 0 0 1-.441.588 9 9 0 0 0-.286.365c-.215.297-.316.52-.316.723V8.5a.5.5 0 0 1-1 0v-.333c0-.533.262-.973.508-1.311.103-.143.217-.284.32-.412q.032-.037.061-.075a5 5 0 0 0 .313-.419.833.833 0 0 0-.702-1.283M7.328 10.834c0-.368.299-.667.667-.667H8A.667.667 0 0 1 8 11.5h-.006a.667.667 0 0 1-.667-.666",
  "clip-rule": "evenodd"
}, null, -1), c = [
  n,
  r
];
function d(i, a) {
  return l(), o("svg", t, [...c]);
}
const u = { render: d };
export {
  u as default,
  d as render
};
